import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export type Options = {
  period: number
}

export type Attrs = Options

export class ATRConfig extends IndicatorBaseConfig {
  static type = IndicatorType.Atr
  static abbreviation = 'atr'
  static label = 'Average True Range'
  static shortLabel = 'ATR'
  static description =
    'The Average True Range (ATR) measures market volatility by calculating the average price range over a specific period. It helps traders gauge the potential price movement and set appropriate stop-loss and take-profit levels.'

  static optionsOrder = ['period'] as const
  static optionsLabels = { period: 'Period' }
  static inputsOrder = this.optionsOrder
  static inputsLabels = this.optionsLabels
  static calculatedValuesOrder = ['atr'] as const
  static calculatedValuesLabels = { atr: 'ATR' }
  static defaultCalculatedValueOption = this.calculatedValuesOrder[0]
}
